// src/utils/dbConfig.js

/**
 * Configuration for each dataset type.
 *   • getDbName(year, provinceKey) → dataset identifier used by frontend data loaders
 *   • getProvinceField(year, provinceKey) → the column name that holds province IDs
 */
export const DB_CONFIG = {
  democracy_checkup: {
    // e.g. year=2021 → "2021_democracy_checkup_clean" (used as `table` for /api/democracy_checkup)
    getDbName: (year) => `${year}_democracy_checkup_clean`,
    // e.g. year=2021 → "dc21_province"
    getProvinceField: (year) => `dc${String(year).slice(-2)}_province`,
  },

  provincial_election: {
    // e.g. year=2023, provinceKey="alberta" → "2023_alberta_election"
    getDbName: (year, prov) => `${year}_${prov}_election`,
    // in your Alberta datasets this is always "csp_province"
    getProvinceField: () => `csp_province`,
  },

  canadian_phone: {
    // e.g. year=2024 → "2024_Canadian_phone"
    getDbName: (year) => `${year}_Canadian_phone`,
    // no province column here
    getProvinceField: () => null,
  },

  // ← you can add more datasets here as needed
};

/**
 * Given a datasetKey and the selected year/provinceKey,
 * returns { dbName, provinceCol } for data loading and grouping rows.
 */
export function getDbSettings(datasetKey, { year, provinceKey } = {}) {
  const cfg = DB_CONFIG[datasetKey];
  if (!cfg) {
    throw new Error(`Unknown datasetKey: "${datasetKey}"`);
  }

  return {
    dbName: cfg.getDbName(year, provinceKey),
    provinceCol: cfg.getProvinceField(year, provinceKey),
  };
}
